import { Link } from "react-router-dom";

interface HeroBannerProps {
    label: string;
    imgSrc?: string;
    ctaLabel?: string;
    ctaHref?: string;
}

export const HeroBanner = ({
    label,
    imgSrc,
    ctaLabel,
    ctaHref,
}: HeroBannerProps) => {
    return (
        <section
            data-testid="hero-banner"
            className="relative w-full overflow-hidden bg-base-300"
        >
            {imgSrc && (
                <img
                    src={imgSrc}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                />
            )}
            <div className="relative px-4 py-12 md:py-20">
                <h2 className="text-2xl md:text-4xl font-bold text-neutral mb-4">
                    {label}
                </h2>
                {ctaLabel && ctaHref && (
                    <Link to={ctaHref} className="btn btn-primary">
                        {ctaLabel}
                    </Link>
                )}
            </div>
        </section>
    );
};
